module.exports = __webpack_public_path__ + "img/72.291d8eef.jpg";